import * as React from 'react';
import { Typography } from '@mui/material';
import Fade from '@mui/material/Fade';
import InfoCard from './Card.js';
import Grid from '@mui/material/Grid';
import TitleChange from './titleChanger.js';


function PhantDetails() {
    return (
        <div>
            <Grid variant='container'>
                <Grid variant='item'>
                    <Typography variant='body1'>Phantasmagoria</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Delaney Stockli - Violin</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Jim Funnell - Piano</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Akiko Hari - Percussion</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Maya Orchin - Choreography</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Fraser A Campbell - Clarinet, Composition</Typography>
                </Grid>
            </Grid>
        </div >

    )
};
function TransFadeDetails() {
    return (
        <div>
            <Grid variant='container'>
                <Grid variant='item'>
                    <Typography variant='body1'>Transport Fade</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Delaney Stockli - Composition, Violin, Production</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Maya Orchin - Choreography</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Fraser A Campbell - Composition, Woodwinds, Production</Typography>
                </Grid>
            </Grid>
        </div >

    )
};
function MurmurDetails() {
    return (
        <div>
            <Grid variant='container'>
                <Grid variant='item'>
                    <Typography variant='body1'>Murmur</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Sarah Takash - Dance / Choreography</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Zach Lapidus - Buchla</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Fraser A Campbell - Clarinet</Typography>
                </Grid>
            </Grid>
        </div >

    )
};
function UnitedDetails() {
    return (
        <div>
            <Grid variant='container'>
                <Grid variant='item'>
                    <Typography variant='body1'>Alice in Wonderland</Typography>
                </Grid>
                <br></br>
                <Grid variant='item'>
                    <Typography variant='body1'>United Dance's Production of Alice in Wonderland featuring:</Typography>
                </Grid>
                <br></br>
                <Grid variant='item'>
                    <Typography variant='body1'>Hannah Kendrick - Alice</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Casey O'Donnell - White Rabbit</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Faye Jones - Red Queen</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Adam Lewis - Tweedledum</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Brady Maher - Tweedledee</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Avery Saulnier de Reyes - Alice's Mother</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Juliet Brown - Cat</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Gianni Di Marco - Choreography</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Boris Richir - Director</Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'>Fraser A Campbell - Compositions / Arrangements</Typography>
                </Grid>
            </Grid>
        </div >

    )
};


function Dance() {

    TitleChange("Dance");

    return (
        <div className="App-container">
            <Fade in mountOnEnter unmountOnExit timeout={3000}>
                <Typography sx={{ marginTop: { xs: '7rem', md: '5rem' }, marginBottom: '5rem' }} variant="h2" color="gold">Dance</Typography>
            </Fade>
            <Grid container maxWidth='90vw' spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 6, md: 8, lg: 12 }} justifyContent='center' >
                <Grid variant='item'>
                    <InfoCard MediaInfo={UnitedDetails}
                        cardComp='iframe'
                        textURL="https://www.youtube.com/embed/0sEcJEhd01s?si=6f1ZaQy7gJ6XBHQe"
                        textTitle="Alice in Wonderland - United Dance" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={MurmurDetails}
                        cardComp='iframe'
                        textURL="https://youtube.com/embed/bL8XMrd-sjc"
                        textTitle="Murmur #1" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={MurmurDetails}
                        cardComp='iframe'
                        textURL="https://youtube.com/embed/URV6ZY81Ykc"
                        textTitle="Murmur #2" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={MurmurDetails}
                        cardComp='iframe'
                        textURL="https://youtube.com/embed/mQlHtBfj-A0"
                        textTitle="Murmur #3" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={MurmurDetails}
                        cardComp='iframe'
                        textURL="https://youtube.com/embed/zCxfwXPBr2s"
                        textTitle="Murmur #4" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={MurmurDetails}
                        cardComp='iframe'
                        textURL="https://youtube.com/embed/vF2iq-jaIFI"
                        textTitle="Murmur #5" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={MurmurDetails}
                        cardComp='iframe'
                        textURL="https://youtube.com/embed/rdBGCt4YcSU"
                        textTitle="Murmur #6" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={MurmurDetails}
                        cardComp='iframe'
                        textURL="https://youtube.com/embed/fqYLEfEeS3c"
                        textTitle="Murmur #7" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={PhantDetails}
                        cardComp='iframe'
                        textURL="https://player.vimeo.com/video/200411860"
                        textTitle="Phantasmagoria" />
                </Grid>
                <Grid variant='item'>
                    <InfoCard MediaInfo={TransFadeDetails}
                        cardComp='iframe'
                        textURL="https://player.vimeo.com/video/193950872"
                        textTitle="Transport Fade" />
                </Grid>
            </Grid>
        </div>
    )
};

export default Dance;